import script from "./afterWorkReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./afterWorkReport.vue?vue&type=script&setup=true&lang=ts"

import "./afterWorkReport.vue?vue&type=style&index=0&id=2988f77d&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2988f77d"]])

export default __exports__